import React from 'react';
import { Badge } from '@/components/ui/badge';

function POGrnItemRow({ item, idx, grnHistory }) {
  const ordered = item.quantity || 0;
  const received = grnHistory?.item_summary?.received?.[item.product_id] || 0;
  const pending = grnHistory?.item_summary?.pending?.[item.product_id] || ordered;
  const isComplete = pending === 0;

  return (
    <tr className={`hover:bg-gray-50 ${isComplete ? 'bg-green-50/30' : ''}`}>
      <td className="px-4 py-2">{item.product_name}</td>
      <td className="px-4 py-2 text-center font-medium">{ordered}</td>
      <td className="px-4 py-2 text-center text-green-600 font-medium">{received}</td>
      <td className="px-4 py-2 text-center text-orange-600 font-medium">{pending}</td>
      <td className="px-4 py-2 text-center">
        {isComplete ? (
          <Badge className="bg-green-100 text-green-700 text-xs">Complete</Badge>
        ) : received > 0 ? (
          <Badge className="bg-orange-100 text-orange-700 text-xs">Partial</Badge>
        ) : (
          <Badge className="bg-gray-100 text-gray-600 text-xs">Pending</Badge>
        )}
      </td>
    </tr>
  );
}

export { POGrnItemRow };
